import { create } from "zustand";

interface FilterState {
  filters: Record<string, any>;
  setFilters: (filters: FilterState["filters"]) => void;
  resetFilters: () => void;
}

const defaultFilters: FilterState["filters"] = {
  query: { value: "", matchMode: "contains" },
  documentTypeName: { value: "", matchMode: "contains" },
  employeeName: { value: "", matchMode: "contains" },
  invoiceYear: { value: "", matchMode: "equals" },
  invoiceMonth: { value: "", matchMode: "equals" },
  invoiceStatus: { value: "", matchMode: "contains" },
};

export const useFilterInvoiceGridStore = create<FilterState>((set) => ({
  filters: defaultFilters,
  setFilters: (filters) => set({ filters }),
  resetFilters: () => set({ filters: defaultFilters }),
}));
